import React from "react";
import { ButtonFluxiProps } from "./ButtonFluxiInterface";

export const ButtonFluxi: React.FC<ButtonFluxiProps> = ({
  icon,
  text = "",
  onClick,
  children,
  fullWidth = false,
  isEffect = true,
  style = {},
  disabled = false,
  type = "submit",
  gradient_from = "#5050EA",
  gradient_to = "#85A2FF",
  border_color = "transparent",
  color = "white",
}) => {
  return (
    <button
      type={type}
      className={`
        flex 
        items-center 
        p-3 
        bg-gradient-to-r from-[${gradient_from}] to-[${gradient_to}] 
        text-lg font-medium 
        rounded-xl 
        transition-opacity 
        relative 
        overflow-hidden 
        gap-2
        ${border_color !== "transparent" ? "border" : ""}
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"}`}
      style={{...style, width: fullWidth ? "100%" : "auto", justifyContent: "center", color: color, borderColor: border_color }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className={`relative z-10`}>{icon}</span>}
      {text && <span className={`relative z-10`}>{text}</span>}
      {children}
      {isEffect && <div className="absolute inset-0 bg-white/20 skew-x-[-45deg] translate-x-[-100%] animate-shine" />}
    </button>
  );
};
